import { r as redirect } from "./index.js";
import { P as PUBLIC_AUTH_ENDPOINT, a as PUBLIC_API_PATH } from "./public.js";
function server2server(serverObject) {
  return {
    reauthenticate() {
      throw redirect(302, PUBLIC_AUTH_ENDPOINT + "?redirect=" + serverObject.url.origin);
    },
    requiresLogin() {
      const loggedIn = serverObject.locals.fetchAuthHeaders.Authorization;
      if (!loggedIn) {
        this.reauthenticate();
      }
      return loggedIn;
    },
    async post(url, body) {
      const call = await fetch(PUBLIC_API_PATH + url, {
        method: "POST",
        headers: serverObject.locals.fetchAuthHeaders,
        body: JSON.stringify(body)
      });
      if (!call.ok) {
        throw new Error(call.statusText);
      }
      try {
        return await call.json();
      } catch (e) {
        throw new Error(call.statusText);
      }
    },
    async put(url, body) {
      const call = await fetch(PUBLIC_API_PATH + url, {
        method: "PUT",
        headers: serverObject.locals.fetchAuthHeaders,
        body: JSON.stringify(body)
      });
      if (!call.ok) {
        throw new Error(call.statusText);
      }
      try {
        return await call.json();
      } catch (e) {
        throw new Error(call.statusText);
      }
    },
    async get(url) {
      const call = await fetch(PUBLIC_API_PATH + url, {
        method: "GET",
        headers: serverObject.locals.fetchAuthHeaders
      });
      if (!call.ok) {
        throw new Error(call.statusText);
      }
      try {
        return await call.json();
      } catch (e) {
        throw new Error(call.statusText);
      }
    }
  };
}
export {
  server2server as s
};
//# sourceMappingURL=server2server.js.map
